var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmChipRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2093"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_356",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 54.5C109 84.5995 84.5995 109 54.5 109C24.4005 109 0 84.5995 0 54.5C0 24.4005 24.4005 0 54.5 0C84.5995 0 109 24.4005 109 54.5ZM4.6807 54.5C4.6807 82.0144 26.9856 104.319 54.5 104.319C82.0144 104.319 104.319 82.0144 104.319 54.5C104.319 26.9856 82.0144 4.6807 54.5 4.6807C26.9856 4.6807 4.6807 26.9856 4.6807 54.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109 54.5C109 84.5995 84.5995 109 54.5 109C24.4005 109 0 84.5995 0 54.5C0 24.4005 24.4005 0 54.5 0C84.5995 0 109 24.4005 109 54.5ZM4.6807 54.5C4.6807 82.0144 26.9856 104.319 54.5 104.319C82.0144 104.319 104.319 82.0144 104.319 54.5C104.319 26.9856 82.0144 4.6807 54.5 4.6807C26.9856 4.6807 4.6807 26.9856 4.6807 54.5Z",
    fill: "#202020",
    stroke: "url(#paint0_radial_0_356)",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_0_356)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_356",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.5 -54.5 -0.0199731 759.477 54.5 54.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE743",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmChipRing);
export default __webpack_public_path__ + "static/media/hmChipRing.99c5adf49ce2346081c30c510b6a3518.svg";
export { ForwardRef as ReactComponent };